import { GridOptions } from "ag-grid-community";
import { LoggerService } from "@bfx/logger";
import { NgZone } from "@angular/core";
const logger = LoggerService.for(__dirname);

export const AgGridEditableBodyScroll =
  (component: { gridOptions: GridOptions; zone: NgZone }) => (event) => {
    try {
      if (component.gridOptions.api) {
        let editingCells = component.gridOptions.api.getEditingCells();

        if (Array.isArray(editingCells) && editingCells.length > 0) {
          component.gridOptions.api.doLayout();

          component.zone.run(() => {
            let editingCells = component.gridOptions.api.getEditingCells();
            if (Array.isArray(editingCells) && editingCells.length > 0) {
              component.gridOptions.api.stopEditing();
              component.gridOptions.api.clearFocusedCell();
              logger.out.info(
                `${component.constructor.name}.onBodyScroll event stop editing`,
                event,
              );
            }
          });
        }
      } else {
        logger.out.error(
          `${component.constructor.name}.onBodyScroll event:%O error stopping edit:%O`,
          event,
        );
      }
    } catch (e) {
      logger.out.error(
        `${component.constructor.name}.onBodyScroll event:%O error stopping edit:%O`,
        event,
        e,
      );
    }
  };
